'use client';

import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@/app/components/form/Input';
import { SingleDatePicker } from '@/app/components/form/SingleDatePicker';
import type { CreateClientFormData } from '@/types/clientsApiTypes';

const basePath = 'primary_passenger.tsa';
const passportPath = 'primary_passenger.passport';

export const EditTravelDataForm = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext<CreateClientFormData>();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Input {...register(`${basePath}.global_entry`)} intent="primaryWhite" label="Global entry number" />

      <Controller
        name={`${basePath}.global_expiry_date`}
        control={control}
        render={({ field }) => (
          <SingleDatePicker
            name={`${basePath}.global_expiry_date`}
            label="Global entry expiry date"
            minDate={new Date()}
            intent="primaryWhite"
            errors={errors}
            value={field.value || ''}
            onChangeDate={(date) => field.onChange(date)}
          />
        )}
      />

      <Input
        {...register(`${basePath}.known_traveler_number`)}
        intent="primaryWhite"
        label="Known traveler number (KTN)"
      />

      <Controller
        name={`${basePath}.known_traveler_number_expire_date`}
        control={control}
        render={({ field }) => (
          <SingleDatePicker
            name={`${basePath}.known_traveler_number_expire_date`}
            label="KTN expiry date"
            minDate={new Date()}
            intent="primaryWhite"
            errors={errors}
            value={(field.value as string) || ''}
            onChangeDate={(date) => field.onChange(date)}
          />
        )}
      />

      <Input
        {...register(`${passportPath}.passport_number`)}
        value={(watch(`${passportPath}.passport_number`) as string) ?? ''}
        intent="primaryWhite"
        label="Passport number"
      />

      <Controller
        name={`${passportPath}.expiry_date`}
        control={control}
        render={({ field }) => (
          <SingleDatePicker
            name={`${passportPath}.expiry_date`}
            label="Passport expiry date"
            minDate={new Date()}
            intent="primaryWhite"
            errors={errors}
            value={(field.value as string) || ''}
            onChangeDate={(dateStr) => {
              field.onChange(dateStr);
            }}
          />
        )}
      />
    </div>
  );
};
